module.exports = __webpack_public_path__ + "img/dynamicLogo3.0d86c5f7.png";